export const diaChiLayHang = {
  sections: {
    list: { title: 'Địa chỉ lấy hàng' },
    detail: { title: 'Địa chỉ lấy hàng' },
  },
  titles: { add: 'Thêm địa chỉ lấy hàng', edit: 'Sửa địa chỉ lấy hàng' },
  columns: {
    chiNhanh: 'Chi nhánh',
    khoVatLy: 'Kho vật lý',
    phone: 'Điện thoại',
    address: 'Địa chỉ',
    province: 'Tỉnh/Thành',
    district: 'Quận/Huyện',
    ward: 'Phường/Xã',
    viDo: 'Vĩ độ',
    kinhDo: 'Kinh độ',
    viewLocation: 'Vị trí',
    default: 'Mặc định',
    note: 'Ghi chú',
    ngayTao: 'Ngày tạo',
    ngayCapNhat: 'Ngày cập nhật',
    status: 'Trạng thái',
    onOffAction: 'Bật tắt',
  },
  filter: {
    searchPlaceholder: 'Tìm theo địa chỉ / điện thoại / tỉnh...',
    textDetailTitle: 'Bộ lọc chi tiết',
  },
  filters: {
    hintSection: 'Gợi ý',
    hintBody:
      'Mỗi dự án + chi nhánh có danh sách địa chỉ lấy hàng riêng, trong đó 1 địa chỉ mặc định.',
    statusAll: 'Tất cả',
    defaultOnly: 'Chỉ mặc định',
    chiNhanhAll: 'Tất cả chi nhánh',
  },
  status: {
    dangHoatDong: 'Đang hoạt động',
    ngungHoatDong: 'Ngừng hoạt động',
  },
  actions: {
    pause: 'Ngừng hoạt động',
    activate: 'Kích hoạt',
    viewLocation: 'Xem vị trí',
    noLocation: 'Chưa có tọa độ',
  },
  messages: {
    loadError: 'Không tải được danh sách địa chỉ lấy hàng.',
    deleteSuccess: 'Đã xóa địa chỉ lấy hàng.',
    noData: 'Không có địa chỉ lấy hàng.',
    listSummary: 'Tổng {count} mục',
    saveSuccess: 'Đã lưu địa chỉ lấy hàng.',
    statusChanged: 'Đã cập nhật trạng thái.',
    selectedCount: 'Đã chọn {count}',
    deleteSelected: 'Xóa đã chọn ({count})',
    bulkDeleteConfirm: 'Xóa {count} địa chỉ lấy hàng đã chọn?',
    bulkDeleteSuccess: 'Đã xóa {count} địa chỉ lấy hàng',
    bulkDeletePartial: 'Đã xóa {ok}/{total}. {failed} mục không xóa được.',
    bulkDeleteError: 'Xóa hàng loạt thất bại',
    bulkDeleteNoneSelected: 'Chưa chọn địa chỉ lấy hàng nào để xóa',
  },
  form: {
    chiNhanh: 'Chi nhánh',
    dienThoai: 'Điện thoại',
    diaChi: 'Địa chỉ chi tiết',
    tinhThanh: 'Tỉnh / Thành phố',
    phuongXa: 'Phường / Xã',
    viTriBanDo: 'Vị trí bản đồ',
    chonTuBanDo: 'Chọn từ bản đồ',
    chonViTriTitle: 'Chọn vị trí trên bản đồ',
    xacNhanViTri: 'Xác nhận vị trí',
    viTriHienTai: 'Vị trí hiện tại',
    xoaViTri: 'Xóa vị trí',
    viDo: 'Vĩ độ',
    kinhDo: 'Kinh độ',
    banDoHuongDan: 'Bấm vào bản đồ hoặc kéo marker để chọn vị trí.',
    banDoHuongDanNgan: 'Chưa chọn vị trí. Bấm “Chọn từ bản đồ” để ghim tọa độ.',
    coordsFormat: 'Vĩ độ: {viDo} · Kinh độ: {kinhDo}',
    geoDenied:
      'Không có quyền truy cập vị trí. Hãy cho phép định vị trong trình duyệt.',
    geoUnavailable: 'Không lấy được vị trí hiện tại.',
    reverseFailed:
      'Đã ghi nhận tọa độ. Không lấy được địa chỉ chi tiết từ bản đồ — vui lòng nhập tay.',
    macDinh: 'Đặt làm địa chỉ mặc định của chi nhánh',
    ghiChu: 'Ghi chú',
  },
  validation: {
    chiNhanhRequired: 'Vui lòng chọn chi nhánh.',
  },
  placeholders: {
    formTitle: 'Địa chỉ lấy hàng',
    formBody: '',
    provinceEmpty: '— Chọn Tỉnh/Thành —',
    wardEmpty: '— Chọn Phường/Xã —',
    addressSearch: 'Gõ địa chỉ hoặc dán link Maps / tọa độ từ Zalo',
    addressNoOptions: 'Không có gợi ý địa chỉ',
    viDo: 'VD: 10.7769',
    kinhDo: 'VD: 106.7009',
  },
  aria: {
    columnPicker: 'Chọn cột hiển thị',
  },
}
